<i-title [text]="'list.title' | translate" />

<div class="constatation">
  @if (points.length > 0 && iMapConfig) {
    <div class="constatation__map">
      <i-map
        [token]="iMapToken"
        [iPoints]="points"
        [iMap]="iMapConfig"
        [isNavigationEnabled]="false"
        [iMapField]="{
          title: 'global.constatation' | translate,
          items: [
            { value: 'constatation.id' | translate, key: 'id', size: 'full' },
            {
              value: 'constatation.offence-id' | translate,
              key: 'offenceId',
              size: 'half'
            },
            {
              value: 'constatation.offence-type' | translate,
              key: 'offenceType',
              size: 'half'
            }
          ]
        }"
      >
      </i-map>
    </div>
  } @else if (items.length > 0 && points.length === 0) {
    <div class="constatation__map constatation__map--empty">
      {{ 'list.map-empty' | translate }}
    </div>
  }


  <div class="constatation__list" *ngIf="config">
    <i-table-v2
      [id]="'constatation'"
      [loading]="loading"
      [columns]="columns"
      [items]="items"
      [config]="config"
      (onFastSearch)="search($event)"
      (onSelectedRow)="goToDetail($event)"
      (pageChange)="pageChange($event)"
    >
      <i-tabs
        [tabs]="tabs"
        [activeTab]="currentTabId"
        (tabChange)="tabChange($event)"
      ></i-tabs
    ></i-table-v2>
  </div>
</div>
